import React from 'react';
import { Helmet } from 'react-helmet';
import RoutingPage from './RoutingPage';

function App() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Roop Sweets",
    "url": "https://roopsweets.in",
    "logo": "https://roopsweets.in/images/shoplogo.jpg",  // This is for structured data
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-9988756318",
      "contactType": "Customer Service"
    }
  };

  return (
    <>
      <Helmet>
        <link rel="icon" href="https://roopsweets.in/favicon.ico" type="image/x-icon" />

        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <RoutingPage />
    </>
  );
}

export default App;
